import withStartUpApp from '@/bootstarp/startup';
import Layout from '@/components/layout/Layout.vue';
import createRouter from '@/router';

withStartUpApp(Layout, {
  beforeMount(app) {
    createRouter(app, [
      {
        path: '/',
        component: () => import('@/pages/book/booklist.vue'),
      },
    ]);
  },
});
